module.exports = __webpack_public_path__ + "img/sdg-onu-br.403ef965.png";